import { render, staticRenderFns } from "./DataQuality.vue?vue&type=template&id=8477de18&scoped=true"
import script from "./DataQuality.vue?vue&type=script&lang=js"
export * from "./DataQuality.vue?vue&type=script&lang=js"
import style0 from "./DataQuality.vue?vue&type=style&index=0&id=8477de18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_9b90bd239842d9ab132761d251f24808/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8477de18",
  null
  
)

export default component.exports